import * as React from "react";
import { ExpandedStates } from "./ExpandedStates";
import { colors } from "./styles";
export const StatesItem = React.memo(({ id, history, transitions, toggleExpanded, isMounted, isExpanded, triggerTransitions, }) => {
    const currentState = history.find((item) => item.type === "state");
    return (React.createElement("li", { style: {
            padding: "0 2rem",
            fontSize: "18px",
            borderBottom: `1px solid ${colors.border}`,
            opacity: isMounted ? 1 : 0.5,
        } },
        React.createElement("div", { style: {
                cursor: "pointer",
                marginBottom: "0.5rem",
                marginTop: "0.5rem",
                display: "flex",
                alignItems: "center",
            }, onClick: () => {
                toggleExpanded(id);
            } },
            React.createElement("span", { style: {
                    color: colors.text,
                    marginRight: "0.5rem",
                    fontSize: "14px",
                } }, isExpanded ? "▼" : "▶"),
            React.createElement("span", { style: {
                    color: colors.highlight,
                    fontWeight: "bold",
                    marginRight: "0.5rem",
                } }, id),
            " ",
            React.createElement("span", { style: { color: colors.orange } }, currentState.state.state)),
        isExpanded ? (React.createElement(ExpandedStates, { triggerTransitions: triggerTransitions, history: history, transitions: transitions, currentState: currentState.state.state })) : null));
});
//# sourceMappingURL=StatesItem.js.map